import { GLBData } from '@types'
import { getProxyUrl } from '.'

export async function getGLBData(catalogID: string | number, realCatalogID?: string) {
  const normalizeCushionResponse = (requestedCatalog: string | number, json: any) => {
    const requested = String(requestedCatalog || '').trim()
    const requestedNorm = requested
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
    const isCushionRequest = requestedNorm.includes('cojin')
    if (!isCushionRequest || !json) return json

    // El backend puede devolver referencia "Cojines 6-95" aun cuando se pide
    // "Cojines 6-100". Conservamos geometría/blender, pero normalizamos metadatos
    // para que el flujo de cliente respete la referencia solicitada.
    return {
      ...json,
      codigo: requested,
      referencia: requested,
      descripcion: requested,
    } as GLBData
  }

  if (typeof catalogID === 'number') {
    const url = getProxyUrl(`api/Unidades/getunidad/${catalogID}`)
    const params: RequestInit = {
      method: 'GET',
      mode: 'cors',
      headers: {
        // TODO: Maybe  add user language
        'Accept-Language': 'ES',
        'Content-Type': 'application/json',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    }
    const data = await fetch(url, params)
    if (data.status === 200) {
      const json = await data.json()
      if (json) return normalizeCushionResponse(catalogID, json) as GLBData
    } else {
      return null
    }
  }
  try {
    const url = getProxyUrl('api/Unidades/getunidad')
    const body = JSON.stringify({
      codigo: catalogID,
      date: '2023-05-12',
      catalogoId: realCatalogID ?? catalogID,
    })

    const params: RequestInit = {
      body,
      method: 'POST',
      mode: 'cors',
      headers: {
        'Accept-Language': 'ES',
        'Content-Type': 'application/json',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    }
    const data = await fetch(url, params)

    if (data.status === 200) {
      const json = await data.json()

      if (json) return normalizeCushionResponse(catalogID, json) as GLBData
    } else {
      const errorText = await data.text()
      // Para laterales (LA, LB, LC, CC, CB), usar warning en lugar de error ya que es esperado que algunos no existan
      const isLateral = typeof catalogID === 'string' && /^(LA|LB|LC|CC|CB)\d+/.test(catalogID)
      if (isLateral && data.status === 404) {
        // No mostrar nada aquí, se manejará en el nivel superior
        return null
      }
      console.error(`❌ getGLBData: Error response: ${errorText}`)
      return null
    }
  } catch (e: any) {
    console.error('Error en getGLBData:', e as Error)
    return null
  }
}
